/* eslint-disable @typescript-eslint/no-explicit-any */
import { useEffect } from "react";
import { Load } from "components/load";
import { columns } from "../components/columns";
import { ExportButton } from "../components/excel-report";
import { DataTable } from "../components/data-table";
import { toast } from "components/ui/use-toast";
import { useCashBalanceState } from "../ducks/hooks/state";
import { useGetRecordsCashBalanceQuery } from "@/services/cash-balance";
import { useFilterActions } from "../ducks/hooks/action";
import { ContentContainer, PageLayout, PageTitle } from "components/layout";


export const ReportBalanceCashList: React.FC = () => {
  const filterState = useCashBalanceState();
  const { clearFilters } = useFilterActions();

  useEffect(() => {
    clearFilters();
  }, []);

  const baseFilters = {
    meta: {
      page: filterState.filters.meta?.page || 1,
      perPage: filterState.filters.meta?.perPage || 10,
    },
  };

  const dynamicFilters = Object.entries(filterState.filters).reduce(
    (acc, [key, value]) => {
      if (value) acc[key] = value;
      return acc;
    },
    {} as Record<string, any>
  );

  const filters = { ...baseFilters, ...dynamicFilters };

  const {
    data: cashBalance,
    isLoading,
    isFetching,
    error,
  } = useGetRecordsCashBalanceQuery(filters);

  const { data, meta } = cashBalance || {
    data: [],
    meta: { page: 1, perPage: 10, total: 0, totalPages: 0 },
  };

  if (isLoading) return <Load />;

  if (error) {
    toast({
      description: "Erro ao buscar o saldo. Tente novamente.",
      variant: "destructive",
    });
  }

  return (
    <PageLayout>
      <PageTitle title="Relatório de Saldo de Caixa" description="Gerencie os registros de saldo de caixa" />
      <ContentContainer>
        <DataTable
          data={data as any}
          columns={columns}
          meta={meta as any}
          isLoading={isFetching}
          actions={<ExportButton excelFile={cashBalance?.excelBase64 || ""} />}
        />
      </ContentContainer>
    </PageLayout>
  );
};
